
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Добавьте его на экран «Домой» — это откроет дополнительные возможности и сделает использование удобнее.`,
's224cbcec014ef6b5': `Нажмите "Поделиться"`,
's37a9e8aec5713460': `Подробнее`,
's386eca8362ff6155': `Нажмите "Еще", если нет значка "Поделиться"`,
's4e1e10a6ca408245': `Нажмите "Добавить на главный экран"`,
's6196153c4b0c1ea0': `Установить`,
's633502f7cff4f847': `Откройте меню вашего браузера`,
's681e399d63311fba': `Показать галерею`,
's7f0591f08e318eda': `Нажмите "Еще" в меню "Поделиться"`,
's8114bd55cae5a22b': `Нажмите "Добавить в Dock"`,
's922329d6f6213590': `Добавить в Dock`,
's9af56bf005b49c74': `Прокрутите вниз до "На экран «Домой»"`,
'sa5ef80b4bb9b39f8': `Свернуть`,
'sba52286c21552a4e': `Установите это на ваше устройство, чтобы получить дополнительные возможности и удобство использования.`,
'sc16e00a7a8b2fde2': `Назад`,
'scdaf4bbff76674c8': `На экран «Домой»`,
'se0e473adfda8066c': `Откройте в вашем основном браузере`,
'se740f75b95a51807': `Добавьте его в Dock — это откроет дополнительные возможности и сделает использование удобнее.`,
'sfea652f6580ff086': `Этот веб-сайт имеет функционал приложения.`,
    };
  